var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFigmaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41491 0C5.96837 0 4 2.05277 4 4.56757C4 6.09676 4.72765 7.45467 5.84715 8.28379C4.72765 9.1129 4 10.4708 4 12C4 13.5292 4.72765 14.8871 5.84715 15.7162C4.72765 16.5453 4 17.9032 4 19.4324C4 21.9472 5.96837 24 8.41491 24C10.8614 24 12.8298 21.9472 12.8298 19.4324V15.5691C13.5836 16.1932 14.5427 16.5676 15.5853 16.5676C18.0318 16.5676 20.0002 14.5148 20.0002 12C20.0002 10.4708 19.2726 9.1129 18.1531 8.28379C19.2726 7.45467 20.0002 6.09676 20.0002 4.56757C20.0002 2.05277 18.0318 0 15.5853 0H8.41491ZM5.65943 4.56757C5.65943 2.97669 6.90053 1.7027 8.41491 1.7027H11.1704V7.43243H8.41491C6.90053 7.43243 5.65943 6.15845 5.65943 4.56757ZM15.5853 7.43243H12.8298V1.7027H15.5853C17.0997 1.7027 18.3408 2.97669 18.3408 4.56757C18.3408 6.15845 17.0997 7.43243 15.5853 7.43243ZM5.65943 12C5.65943 10.4091 6.90053 9.13514 8.41491 9.13514H11.1704V14.8649H8.41491C6.90053 14.8649 5.65943 13.5909 5.65943 12ZM12.8298 12C12.8298 10.4091 14.0709 9.13514 15.5853 9.13514C17.0997 9.13514 18.3408 10.4091 18.3408 12C18.3408 13.5909 17.0997 14.8649 15.5853 14.8649C14.0709 14.8649 12.8298 13.5909 12.8298 12ZM5.65943 19.4324C5.65943 17.8416 6.90053 16.5676 8.41491 16.5676H11.1704V19.4324C11.1704 21.0233 9.92929 22.2973 8.41491 22.2973C6.90053 22.2973 5.65943 21.0233 5.65943 19.4324Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigmaIcon);
export default __webpack_public_path__ + "static/media/figmaIcon.18c67b9b90c86cb096394cbbdd7c1eb5.svg";
export { ForwardRef as ReactComponent };